import React from 'react';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import PureDialog from 'client/components/dialog/PureDialog';

export default function DialogLoading({ open, desc }) {
    return (
        <PureDialog
            open={open}
            isShowPrimaryButton={false}
            isShowCloseIcon={false}
            modalStyle={modalStyle(99999)}
        >
            <div css={modalContentStyle}>
                <img
                    src="https://assets.fevercdn.com/promotion/icon/promo_init_loading.gif"
                    alt="loading"
                />
                <Typography variant="subtitle2">{desc}</Typography>
            </div>
        </PureDialog>
    );
}

const modalContentStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 180px;
    > img {
        margin-bottom: 8px;
    }
`;

const modalStyle = zIndex => css`
    ${zIndex && `z-index: ${zIndex} !important;`}
`;
